<template>
  <main class="Page">
    <div>
      <h1 class="title">{{ $t('change_country.title') }}</h1>
      <section class="choose-country">
        <div v-for="country in ALL_ENTITES" :key="country" class="country">
          <span class="flag"
            ><img
              :src="require('@/' + `assets/changeCountry/flag-${country}.svg`)"
          /></span>
          <h3 class="country-title">
            <span class="country-title-text">
              {{ $t(`change_country.${country.toLowerCase()}`) }}
            </span>
          </h3>
          <a
            class="lang"
            v-for="([url, text], index) in urls[country]"
            :key="index"
            :href="url"
          >
            <p class="lang-option">
              {{ text }}
            </p>
          </a>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { entity } from '@/../region.json';
import i18n from '../i18n';
import { ALL_ENTITES } from '../shared/entityHelpers';

const urls = {
  GERMANY: [
    ['https://qwello.de/de', i18n.t('change_country.germany.de')],
    ['https://qwello.de/en', i18n.t('change_country.germany.en')],
  ],
  SWEDEN: [
    ['https://qwello.se/sv', i18n.t('change_country.sweden.sv')],
    ['https://qwello.se/en', i18n.t('change_country.sweden.en')],
  ],
  FRANCE: [
    ['https://qwello.fr/fr', i18n.t('change_country.france.fr')],
    ['https://qwello.fr/en', i18n.t('change_country.france.en')],
  ],
  SPAIN: [
    ['https://qwello.es/es', i18n.t('change_country.spain.es')],
    ['https://qwello.es/en', i18n.t('change_country.spain.en')],
  ],
  POLAND: [
    ['https://qwello.pl/pl', i18n.t('change_country.poland.pl')],
    ['https://qwello.pl/en', i18n.t('change_country.poland.en')],
  ],
  UK: [['https://qwello.uk/en', i18n.t('change_country.uk.en')]],
};

export default {
  name: 'ChangeCountry',
  data() {
    return {
      entity,
      urls,
      ALL_ENTITES,
    };
  },
};
</script>

<style scoped>
.Page {
  display: grid;
  place-items: center;
  min-height: 100vh;
  --title-font-size: 24px;
  --lang-options-f-size: 16px;
  --country-f-size: 20px;
  --flag-size: 24px;
}

.choose-country {
  display: flex;
  flex-direction: column;
  margin-bottom: 2em;
}
.country {
  display: grid;
  justify-self: flex-start;
}
.title {
  margin-top: 80px;
  color: #2b4047;
  font-size: var(--title-font-size);
  font-weight: bold;
  font-family: 'Foco';
  text-align: center;
}
.country-title {
  grid-column: 3;
  align-self: center;
  width: max-content;
}
.lang {
  grid-column: 3;
}
.country-title-text {
  grid-column: 3;
  font-size: var(--country-f-size);
  font-weight: bold;
  color: #2b4047;
  text-align: left;
  font-family: 'Foco';
}
.flag {
  grid-column: 1;
  align-self: center;
  width: var(--flag-size);
  margin-right: 15px;
}
.lang-option {
  font-size: var(--lang-options-f-size);
  color: #5e7177;
  text-align: left;
  cursor: pointer;
}
@media (max-width: 767px) {
  .country {
    margin-top: 24px;
    grid-template-columns: 24px 15px 1fr;
  }
}
@media (min-width: 768px) {
  .Page {
    --title-font-size: 30px;
    --lang-options-f-size: 20px;
    --country-f-size: 24px;
    --flag-size: 100%;
  }
  .choose-country {
    margin-top: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 120px;
  }
  .title {
    margin-bottom: 70px;
    margin-top: 0;
  }
  .country {
    padding: 0 2rem;
  }
}
</style>
